import { observer } from 'mobx-react-lite';
import { ComponentProps } from 'react';

import { ActionsColumn } from '~components/Order/ordersDispatchColumns';
import useOrderMenuHandlers from '~hooks/useOrders/useOrderMenuHandlers';
import { openOrderMessagingTab } from '~utils/orders';

interface OrderDispatchActionsProps extends Omit<
  ComponentProps<typeof ActionsColumn>,
  'onDownloadJobCardPdfs' | 'onOpenMessagingTab' | 'onViewLoadDigest'
> {
  isExpanded: boolean;
  onMessagingTabRequest: () => void;
  onToggleExpanded: () => void;
}

const OrderDispatchActions = observer(
  ({
    isExpanded,
    onDownloadFiles,
    onEmailLoadDigest,
    onMessagingTabRequest,
    onToggleExpanded,
    order,
    ...actionsProps
  }: OrderDispatchActionsProps) => {
    const menuHandlers = useOrderMenuHandlers({
      onDownloadFiles,
      onEmailLoadDigest,
      order,
    });

    const openMessagingTab = () =>
      openOrderMessagingTab({ isExpanded, onMessagingTabRequest, onToggleExpanded });

    return (
      <ActionsColumn
        {...actionsProps}
        {...menuHandlers}
        onOpenMessagingTab={openMessagingTab}
        order={order}
      />
    );
  },
);

export default OrderDispatchActions;
